import { PartnerDocumentJSON } from '@jurnee/common/src/entities/PartnerDocument';
import { RateJSON } from '@jurnee/common/src/entities/Rate';
import { getTotalInclTax } from '@jurnee/common/src/utils/partnerDocuments';
import { formatPrice } from '@jurnee/common/src/utils/prices';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from './Field';

interface Props {
  partnerDocuments: PartnerDocumentJSON[];
  rate: RateJSON;
}

export function Price({ partnerDocuments, rate }: Props) {
  const { t } = useTranslation('booking');

  const price = useMemo(() => {
    if (partnerDocuments.length === 0) {
      return '-';
    }

    const totalAmount = getTotalInclTax(partnerDocuments, { rate, target: partnerDocuments[0].currency });

    return formatPrice(totalAmount, partnerDocuments[0].currency);
  }, [partnerDocuments, rate]);

  return <Field label={t('fields.price')} value={price} />;
}